import React, { useEffect, useRef } from 'react';
import useState from 'react-usestateref'
import CustomerDetail from './CustomerDetail'
import { toast } from 'react-toastify';
import EditCustomer from './EditCustomer';
import { InfinitySpin } from 'react-loader-spinner';
import AddCustomer from './AddCustomer';
import { IoMdClose, IoMdCloseCircle } from 'react-icons/io';
import { api_url } from '../../../config';
import { useSelector } from 'react-redux';
import { FaRegEye, FaRegFileArchive } from 'react-icons/fa';
import { GrEdit } from 'react-icons/gr';
import DeleteCustomer from './DeleteCustomer';
import ArchiveCustomer from './ArchiveCustomer';
import { hasPermission } from '../../../Redux/permissionSlice';
import { selectRoles } from '../../../Redux/AuthSlice';
import api from '../../../utils/api';
import ManageCategoriesModal from './ManageCategoriesModal';
import Table from '../../../components/dataUi/Table';
import { formatDate } from '../../../utils/dateUtils';
import { FaGreaterThan } from "react-icons/fa";
import Portal from '../../../utils/Portal';

const CustomerInfo = () => {
    const [showModal, setShowModal] = useState(false)
    const [customer_view, setCustomer_view] = useState(false)
    const [customer, setCustomer] = useState('')
    const [customer_amount, setCustomer_amount] = useState('')
    const [editModal, setEditModal] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)
    const [selectedCustomer, setSelectedCustomer] = useState()
    const [selectedDropdown, setSelectedDropdown] = useState(null);
    const status = ['*', 'All', 'Active', 'Inactive', 'Archived']
    const [loading, setLoading] = useState(true)
    const [filter, setFilter] = useState('')
    const [filter_by, setFilter_by] = useState('')
    const [sortby, setSortby] = useState('-pivot_created_at')
    const [metadata, setMetadata] = useState('')
    const [search, setSearch] = useState('')
    const [hasSearched, setHasSearched] = useState(false);
    const [archiveModal, setArchiveModal] = useState(false)
    const [activeTab, setActiveTab] = useState('All');
    const [categoryModalOpen, setCategoryModalOpen] = useState(false);
    const [categories, setCategories] = useState([]);
    const { id, branch_id, token } = useSelector((state) => state.auth)

    const modalRef = useRef()

    const showEditModal = (event, data) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        setEditModal(!editModal)
        setSelectedCustomer(data)
    }

    const showArchiveModal = (event, data) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        setArchiveModal(!archiveModal)
        setSelectedCustomer(data)
    }

    const popUpRef = useRef()

    const showCustomerDetail = (data) => {
        setCustomer_view(!customer_view)
        setCustomer(data)
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popUpRef.current && !popUpRef.current.contains(event.target)) {
                setSelectedDropdown(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleCustomerForm = (id) => {
        setShowModal(!showModal)
    };

    useEffect(() => {
        fetchCategories();
    }, [id, branch_id, token]);

    const fetchCategories = async () => {
        try {
            console.log('CustomerInfo - Fetching categories');
            const response = await api.get(
                `${api_url}/api/v1/wholesaler/user/${id}/branch/${branch_id}/contact/category`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            console.log('CustomerInfo - Categories Response:', response.data);
            setCategories(response.data);
            return response.data;
        } catch (error) {
            console.error('CustomerInfo - Failed to fetch categories:', error);
            return [];
        }
    };

    const selectedRoles = useSelector(selectRoles);
    const roles = Array.isArray(selectedRoles) ? selectedRoles : selectedRoles.split(',').map(role => role.trim());

    const [customers, setCustomers] = useState([])
    const fetchCustomers = async () => {
        setLoading(true);
        if (!navigator.onLine) {
            toast("You're offline");
            setLoading(false);
            return;
        }

        const categoriesData = await fetchCategories();
        try {
            const response = await api.get(api_url + `/api/v1/wholesaler/user/${id}/branch/${branch_id}/contact/inbranch`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            });
            const data = response.data.data;
            const mappedData = data.map(customer => {
                if (customer.category && customer.category.id) {
                    return customer;
                }
                if (customer.pivot && customer.pivot.category_id) {
                    const matchedCategory = categoriesData.find(cat => cat.id === customer.pivot.category_id);
                    if (matchedCategory) {
                        return {
                            ...customer,
                            category: matchedCategory
                        };
                    }
                }
                return {
                    ...customer,
                    category: null
                };
            });
            setCustomers(mappedData);
            setCustomer_amount(mappedData.length);
        } catch (error) {
            console.error('CustomerInfo - Fetch Error:', error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchCustomers();
    }, [id, token, filter, sortby]);

    const showEmptydivHelper = () => {
        setHasSearched(false)
        setHasSearched(true)
    }

    const switchTab = (value) => {
        setActiveTab(value);
        setLoading(true);
        setHasSearched(false);
        switch (value) {
            case 'All':
                setFilter_by('status');
                setFilter('active,inactive,archived');
                break;
            case 'external':
                setFilter_by(['on_pharmtrix', 'status']);
                setFilter(['0', 'active,inactive,archived']);
                break;
            case 'internal':
                setFilter_by(['on_pharmtrix', 'status']);
                setFilter(['1', 'active,inactive,archived']);
                break;
            default:
                setFilter_by('');
                setFilter('');
        }
    };

    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            setShowModal(false);
            setEditModal(false)
            setDeleteModal(false)
        }
    };

    useEffect(() => {
        if (showModal || editModal || deleteModal) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showModal, editModal]);

    // Table headers configuration
    const headers = [
        { key: 'number', label: 'NO.', sortable: true },
        { key: 'name', label: 'Name', sortable: true, tooltipEnabled: true },
        { key: 'category', label: 'Category', sortable: true },
        { key: 'city', label: 'City', sortable: true },
        { key: 'town', label: 'Town', sortable: true },
        { key: 'address', label: 'Address', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'phone', label: 'Contact', sortable: true },
        {
            key: 'created_at',
            label: 'Date Created',
            sortable: true,
            render: (value) => formatDate(value,)
        },
        { key: 'status', label: 'Status', sortable: true },
    ];

    const formatFilteredCustomersForTable = () => {
        return customers.map((customer, index) => ({
            number: index + 1,    // add a `number` key
            ...customer
        }));
    };


    // Status configuration
    const statusConfig = {
        active: {
            label: 'Active',
            className: 'bg-green-200 text-green-800 border border-green-400'
        },
        inactive: {
            label: 'Inactive',
            className: 'bg-red-200 text-red-800 border border-red-400'
        },
        archived: {
            label: 'Archived',
            className: 'bg-gray-200 text-gray-800 border border-gray-400'
        }
    };

    // Filter options
    const filterOptions = [
        { label: 'Active', value: 'active' },
        { label: 'Inactive', value: 'inactive' },
        { label: 'Archived', value: 'archived' },
    ];

    // Action buttons configuration
    const actions = [
        {
            label: 'View',
            variant: 'primary',
            icon: <FaRegEye className="text-xs" />,
            onClick: (row) => showCustomerDetail(row)
        },
        {
            label: 'Edit',
            variant: 'secondary',
            icon: <GrEdit className="text-xs" />,
            onClick: (row) => showEditModal(null, row),
            showIf: (row) => row.status !== 'archived' && hasPermission(roles, ['retailerWriter', 'retailerAdmin'])
        },
        {
            label: 'Archive',
            variant: 'warning',
            icon: <FaRegFileArchive className="text-xs" />,
            onClick: (row) => showArchiveModal(null, row),
            showIf: (row) => row.status === 'inactive' && hasPermission(roles, ['retailerAdmin'])
        }
    ];

    return (
        <div className='overflow-auto'>
            {!customer_view ? <div className='font-lufga '>
                {loading && (
                    <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full bg-gradient-to-br from-opacity-40 to-opacity-60 backdrop-blur-sm">
                        <InfinitySpin color="#008DDA" loading={loading} size={40} />
                    </div>
                )}
                {!loading && (<div className='w-full '>
                    <div>
                    <div className="flex items-center justify-start w-full gap-2 px-4 mb-3 overflow-x-auto font-lufga sm:gap-4 whitespace-nowrap tabs-scrollbar">
                            <button
                                className={`text-xs sm:text-sm cursor-pointer py-2 px-4 text-nowrap ${activeTab === 'All'
                                    ? 'border-b-2 border-blue-500 text-blue-500'
                                    : 'text-gray-500'
                                    }`}
                                onClick={() => switchTab('All')}
                            >
                                All
                            </button>
                            <button
                                className={`text-xs sm:text-sm cursor-pointer py-2 px-4 text-nowrap ${activeTab === 'external'
                                    ? 'border-b-2 border-blue-500 text-blue-500'
                                    : 'text-gray-500'
                                    }`}
                                onClick={() => switchTab('external')}
                            >
                                Non-Pharmtrix Customers
                            </button>
                            <button
                                className={`text-xs sm:text-sm cursor-pointer py-2 px-4 text-nowrap ${activeTab === 'internal'
                                    ? 'border-b-2 border-blue-500 text-blue-500'
                                    : 'text-gray-500'
                                    }`}
                                onClick={() => switchTab('internal')}
                            >
                                Pharmtrix Registered Retailers
                            </button>
                        </div>
                        <div className='mx-6 font-lufga'>
                            <Table
                                headers={headers}
                                rows={formatFilteredCustomersForTable()}
                                actions={actions}
                                className="mb-6 text-xs shadow-lg"
                                emptyMessage={search ? `No results found for "${search}"` : "No customers available"}
                                headerBgColor="bg-blue-300"
                                onRowClick={showCustomerDetail}
                                title="Customers"
                                itemsPerPage={10}
                                onAdd={toggleCustomerForm}
                                addButtonText="Add Customer"
                                exportButtonText="Export Data"
                                addButtonClassName="bg-blue-500 hover:bg-blue-600 text-xs"
                                filterOptions={filterOptions}
                                statusConfig={statusConfig}
                                showAddButton={hasPermission(roles, ['retailerWriter', 'retailerAdmin'])}
                                cellClassName="py-2 px-3 text-xs"
                                headerClassName="py-2 px-3 text-xs font-medium"
                            />
                        </div>
                    </div>
                    {editModal && (
                        <div className="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
                            <div ref={modalRef} className="p-3 bg-white rounded-md shadow-lg min-h-max z-[9999]">
                                <IoMdCloseCircle size={24} onClick={() => setEditModal(false)} className='transition duration-150 ease-out cursor-pointer hover:scale-105 hover:text-red-800 ' />
                                <EditCustomer toggle={() => setEditModal(false)} data={selectedCustomer} fetchCustomers={fetchCustomers} categories={categories} />
                            </div>
                        </div>
                    )}
                    {deleteModal && (
                        <div className="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
                            <div ref={modalRef} className="p-3 bg-white rounded-md shadow-lg min-h-max z-[9999]">
                                <IoMdCloseCircle size={24} onClick={() => setDeleteModal(false)} className='transition duration-150 ease-out cursor-pointer hover:scale-105 hover:text-red-800 ' />
                                <DeleteCustomer toggle={() => setDeleteModal(false)} data={selectedCustomer} fetchCustomers={fetchCustomers} showEmptydivHelper={showEmptydivHelper} />
                            </div>
                        </div>
                    )}
                    {archiveModal && (
                        <div className="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
                            <div ref={modalRef} className="p-3 bg-white rounded-md shadow-lg min-h-max z-[9999]">
                                <IoMdCloseCircle size={24} onClick={() => setArchiveModal(false)} className='transition duration-150 ease-out cursor-pointer hover:scale-105 hover:text-red-800 ' />
                                <ArchiveCustomer toggle={() => setArchiveModal(false)} data={selectedCustomer} fetchCustomers={fetchCustomers} />
                            </div>
                        </div>
                    )}
                </div>)}

                {showModal && (
                    <Portal>
                        <div className="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
                            <div ref={modalRef} className="p-3 bg-white rounded-md shadow-lg min-h-max z-[9999]">
                                <IoMdClose size={24} onClick={toggleCustomerForm} className='transition duration-150 ease-out cursor-pointer hover:scale-105 hover:text-red-800 ' />
                                <AddCustomer toggle={toggleCustomerForm} fetchCustomers={fetchCustomers} fetchCategories={fetchCategories} categories={categories} />
                            </div>
                        </div>
                    </Portal>
                )}
            </div> :
                <div className='relative'>
                    <div className='mx-10 mt-4'>
                        <p className='text-xl font-semibold lg:text-3xl text-slate-600'>Customer Details</p>
                    </div>
                    <div className='flex items-center gap-2 mx-10 my-2'>
                        <p onClick={() => { setCustomer_view(false) }} className='flex items-center gap-1 text-blue-700 cursor-pointer'>Customers</p>
                        <p className='mt-1'><FaGreaterThan size={14} /></p>
                        <p>Customer Details</p>
                    </div>
                    <div className='grid gap-8 rounded-sm  lg:grid-cols-[minmax(50px,250px)_repeat(5,1fr)] lg:gap-0 mx-8'>
                        <div className='col-span-4 lg:col-span-1 bg-neutral-100'>
                            <div className='flex flex-col gap-2 max-h-[60vh] overflow-auto'>
                                <div className='sticky top-0 p-2 z-1 bg-neutral-100 w-100'>
                                    <p className='w-full text-sm font-semibold font-lufga'>Customer List</p>
                                </div>
                                {customers.map((data) => (
                                    <div key={data.id} className={`cursor-pointer mx-2 p-[1rem]  shadow-md bg-white hover:bg-blue-200 py-2 ${customer.id === data.id ? 'bg-neutral-200' : ''}`} onClick={() => setCustomer(data)}>
                                        <p className='text-sm font-semibold leading-5'>{data?.name}</p>
                                        <p className='text-sm font-bold leading-5 text-gray-600'>{data?.email}</p>
                                        <p className='text-sm font-bold leading-5 text-blue-700'>{data?.city} - {data?.town}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className='col-span-4 p-2 lg:col-span-5'>
                            <p className='mb-4 text-sm font-bold font-lufga'>Details</p>
                            <div className='max-h-[60vh] overflow-auto'>
                                <CustomerDetail toggle={customer_view} fetchCustomers={() => fetchCustomers()} customer={customer} customers={customers} />
                            </div>
                        </div>
                    </div>
                </div>
            }

            {categoryModalOpen && (
                <ManageCategoriesModal
                    isOpen={categoryModalOpen}
                    onClose={() => setCategoryModalOpen(false)}
                    token={token}
                    userId={id}
                    branchId={branch_id}
                    fetchCategories={fetchCategories}
                    categories={categories}
                />
            )}
        </div>
    );
}

export default CustomerInfo;
